module.exports = __webpack_public_path__ + "img/daycoval.d01fc8ac.svg";